import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { appThemeFonts } from "styles/appThemeFonts";

export const DetailTitleRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 10,
  fontFamily: appThemeFonts.family.ui,
});
